"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../types");
function convertBetStatus(betStatus) {
    switch (betStatus) {
        case types_1.GQL.BetStatus.INIT:
        case types_1.GQL.BetStatus.CREATED:
        case types_1.GQL.BetStatus.PLACED:
        case types_1.GQL.BetStatus.ARBITRAGE_ACCEPTED:
        case types_1.GQL.BetStatus.ARBITRAGE_DECLINED:
            return types_1.App.BetslipStatus.PROCESSING;
        case types_1.GQL.BetStatus.ACCEPTED:
        case types_1.GQL.BetStatus.SETTLED:
        case types_1.GQL.BetStatus.UNSETTLED:
        case types_1.GQL.BetStatus.ROLLED_BACK: {
            return types_1.App.BetslipStatus.SUCCESS;
        }
        case types_1.GQL.BetStatus.DECLINED:
        case types_1.GQL.BetStatus.FORCED_DECLINED:
        case types_1.GQL.BetStatus.PLACE_ERROR:
            return types_1.App.BetslipStatus.ERROR;
        default:
            return types_1.App.BetslipStatus.ERROR;
    }
}
exports.default = convertBetStatus;
//# sourceMappingURL=convertBetStatus.js.map